{
    "warning": "எச்சரிக்கை!",
    "message": "உங்களுக்குப் புரியாத குறியீட்டை உள்ளிடாதீர்கள் அல்லது ஒட்டாதீர்கள்.\nஇந்தக் கட்டுப்பாட்டுத் திரையை(Consoleஐ)ப் பயன்படுத்துவதன் மூலம்,தீங்கிழைப்பவர்கள் Self-XSS எனப்படும் தாக்குதலைப் பயன்படுத்தி உங்களைப்போல் நடிக்கவும் உங்கள் தகவல்களைத் திருடவும் முடியும்."
}
